import React from "react";
import { Link } from "react-router-dom";
import paths from "../../routes/paths";
import {
  imageCodes,
  titleCodes,
  textCodes,
} from "../../template_codes/ncici/home_page_codes";

export default function Home() {
  return (
    <div>
      {/*                 banner section           */}
      <div>
        {/* <img src={imageCodes.banImg.image} /> */}
      </div>
      {/*                 end of banner section       */}

      {/*                 category section           */}
      <div className="container w-5/6 md:w-4/6 lg:w-4/6 xl:w-4/6 2xl:w-3/6 pt-10 pb-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-x-4 md:gap-x-8 lg:gap-x-8 xl:gap-x-8 2xl:gap-x-8 gap-y-4">
          <div className="m-5">
            <a href="#">
              <img
                src={imageCodes.addidas.image}
                alt="addidas"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <p className="font-semibold text-center">Addidas Shoe</p>
            </a>
          </div>
          <div className="m-5">
            <a href="#">
              <img
                src={imageCodes.nike.image}
                alt="nike"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <p className="font-semibold text-center">Nike Shoe</p>
            </a>
          </div>
          <div className="m-5">
            <a href="#">
              <img
                src={imageCodes.heel.image}
                alt="Wila Heels / Sandals"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <p className="font-semibold text-center">Wila Heels / Sandals</p>
            </a>
          </div>
          <div className="m-5">
            <a href="#">
              <img
                src={imageCodes.slide.image}
                alt="slides"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <p className="font-semibold text-center">Slides</p>
            </a>
          </div>
          <div className="m-5">
            <a href="#">
              <img
                src={imageCodes.clothing.image}
                alt="clothing"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <p className="font-semibold text-center">Clothing</p>
            </a>
          </div>
          <div className="m-5">
            <a href="#">
              <img
                src={imageCodes.sabina.image}
                alt="sabina"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <p className="font-semibold text-center">Sabina</p>
            </a>
          </div>
        </div>
      </div>
      {/*             end of category section           */}

      {/*                    about section               */}
      <div className="container w-full md:w-3/5 lg:w-3/5 xl:w-3/5 2xl:w-3/5">
        <h1 className="font-bold text-xl text-center pb-10">About Us</h1>
        <p className="text-center px-4">
          Your reliable buyer Since 2020! Both Instock and preorders! Preorder
          items- supplier fees 1000 to 50. 𝟭𝟬𝟬% 𝗮𝘂𝘁𝗵𝗲𝗻𝘁𝗶𝗰, 𝗶𝗳 𝗶𝘁'𝘀 𝗳𝗮𝗸𝗲 𝘄𝗲 𝘄𝗶𝗹𝗹
          𝗿𝗲𝗳𝘂𝗻𝗱 𝘁𝗵𝗲 𝗺𝗼𝗻𝗲𝘆.
        </p>
      </div>
      {/*                  end of about section           */}

      {/*                    shop section                 */}
      <div className="w-fix">
        <div className="lg:pt-10 xl:pt-10 pt-10">
          <h1 className="text-xl lg:text-2xl xl:text-2xl font-semibold text-center pb-10">
            Our Shop
          </h1>
        </div>
        <div className="container grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 pb-10  lg:px-32 xl:px-32 px-4 place-items-center">
          <div className="lg:pl-4 xl:pl-4 pb-10 focus-visible">
            {/* <img src={imageCodes.proImg.image}></img> */}
          </div>
          <div className="lg:pl-4 xl:pl-4 pb-10">
            {/* <img src={imageCodes.proImg.image}></img> */}
          </div>
          <div className="lg:pl-4 xl:pl-4 pb-10 focus-visible">
            {/* <img src={imageCodes.proImg.image}></img> */}
          </div>
        </div>
      </div>
      {/*                 end of shop section                */}

      {/*                    delivery section               */}
      <div className="items-center text-center w-full">
        <div>
          <div className="text-center">
            <h1 className="text-xl font-bold text-center">Delivery</h1>
          </div>
        </div>
        {/*                     ninjavan section             */}
        <div className="grid lg:text-center xl:text:centerlg:grid-cols-3 xl:grid-cols-3 gap-0">
          <div></div>
          <div className="grid grid-cols-4 text-center pt-10">
            <div class="avatar text-center"></div>
            <div class="avatar text-center">
              <div class="w-30 rounded text-center">
                {/* <img src={imageCodes.ninja.image} className="text-center" /> */}
              </div>
            </div>
            <div class=" text-center">
              <div class="w-30 rounded md:text-center">
                <h1 className="font-bold pt-10">Ninja Van</h1>
              </div>
            </div>

            <div class="avatar text-center"></div>
          </div>

          <div></div>
        </div>
        {/*                  end of ninjavan section         */}

        {/*                     wepozt section             */}
        <div className="grid lg:text-center xl:text:centerlg:grid-cols-3 xl:grid-cols-3 gap-0">
          <div></div>
          <div className="grid grid-cols-4 text-center">
            <div class="avatar text-center"></div>
            <div class="avatar text-center">
              <div class="w-30 rounded text-center">
                {/* <img src={imageCodes.wepoz.image} className="text-center" /> */}
              </div>
            </div>
            <div class=" text-center">
              <div class="w-30 rounded md:text-center">
                <h1 className="font-bold pt-10"> Wepozt</h1>
              </div>
            </div>

            <div class="avatar text-center"></div>
          </div>

          <div></div>
        </div>
        {/*                  end of wepozt section             */}
      </div>

      {/*                  end of delivery section           */}

      {/*                    payment section               */}
      <div className="items-center text-center w-full pt-10 pb-10">
        <div>
          <div className="text-center">
            <h1 className="text-xl font-bold text-center">Paymant</h1>
          </div>
        </div>
        {/*                   kpay section             */}
        <div className="grid lg:text-center xl:text:centerlg:grid-cols-3 xl:grid-cols-3 gap-0">
          <div></div>
          <div className="grid grid-cols-4 text-center pt-10">
            <div class="avatar text-center"></div>
            <div class="avatar text-center">
              <div class="w-20 rounded text-center">
                {/* <img src={imageCodes.kpay.image} className="text-center" /> */}
              </div>
            </div>
            <div class=" text-center">
              <div class="w-20 rounded md:text-center">
                <h1 className="font-bold pt-5">09*********</h1>
              </div>
            </div>

            <div class="avatar text-center"></div>
          </div>

          <div></div>
        </div>
        {/*                  end of kpay section           */}

        {/*                   wave section             */}
        <div className="grid lg:text-center xl:text:centerlg:grid-cols-3 xl:grid-cols-3 gap-0">
          <div></div>
          <div className="grid grid-cols-4 text-center">
            <div class="avatar text-center"></div>
            <div class="avatar text-center">
              <div class="w-20 rounded text-center">
                {/* <img src={imageCodes.wave.image} className="text-center" /> */}
              </div>
            </div>
            <div class=" text-center">
              <div class="w-20 rounded md:text-center">
                <h1 className="font-bold pt-5">09*********</h1>
              </div>
            </div>

            <div class="avatar text-center"></div>
          </div>

          <div></div>
          {/*                  end of wave section           */}
        </div>
      </div>

      {/*                  end of payment section           */}
    </div>
  );
}
